import type { vendorApiNames } from '../names';
import type {
  ApiTokenAuthentication,
  UsernamePasswordAuthentication,
} from './auth';
import type {
  BaseUpdateVendorApiSettings,
  BaseUrl,
  BaseVendorApi,
  PaginationSettings,
  RejectUnauthorized,
} from './base';
import type {
  VendorApiHttpAdvancedSettings,
  VendorApiHttpAgentSettings,
} from './http';
import type { VendorApiSessionSettings } from './session';

export interface CiscoFmcSessionSettings extends VendorApiSessionSettings {
  /**
   * Username and password authentication provides both access and refresh token. The access token can be refreshed by refresh token as well as
   * by username and password. The `maxRefreshTokenRefreshCount` sets how many times can the access token be refreshed using refresh token.
   */
  maxRefreshTokenRefreshCount?: number;
}

export interface CiscoFmcDataErrorHandlingSettings {
  /**
   * Cisco FMC sometimes sends 200 OK http response containing no data. The `emptyDataMaxResendCount` sets how many times the request
   * can be resent when it happens.
   */
  emptyDataMaxResendCount?: number;
}

/**
 * Cisco FMC API settings available from API
 */
export type PublicCiscoFmcApiSettings = BaseVendorApi<
  (typeof vendorApiNames)['ciscofmc']
> &
  RejectUnauthorized &
  BaseUrl &
  VendorApiHttpAgentSettings &
  CiscoFmcSessionSettings &
  VendorApiHttpAdvancedSettings &
  PaginationSettings &
  CiscoFmcDataErrorHandlingSettings;

/**
 * Cisco FMC API settings available in backend
 */
export type CiscoFmcApiSettings = PublicCiscoFmcApiSettings &
  (UsernamePasswordAuthentication | ApiTokenAuthentication);

/**
 * Cisco FMC API settings expected on API when updating
 */
export type UpdateCiscoFmcApiSettings = BaseUpdateVendorApiSettings<
  PublicCiscoFmcApiSettings,
  UsernamePasswordAuthentication | ApiTokenAuthentication
>;
